import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuthProvider } from "../auth/hooks/AuthProvider";
import LoadingDots from "./LoadingDots";

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { loginAction } = useAuthProvider();

  const handleLogin = async () => {
    setIsLoading(true);
    await loginAction();
    setIsLoading(false);
  };

  return (
    <main>
      <div className="relative place-items-center h-full">
        <p className="mx-auto text-retta-green mt-16 mb-12 text-xl max-w-96 text-center">
          {t("login-intro")}
        </p>
        <button
          className="text-2xl text-center mt-4 py-2 block m-auto rounded-full w-[100%] min-h-[58px] max-w-96 bg-retta-light-blue 
          text-retta-dark-blue hover:bg-retta-hover-blue hover:text-retta-green disabled:cursor-not-allowed disabled:bg-retta-hover-blue"
          onClick={handleLogin}
          disabled={isLoading}
        >
          {isLoading ? <LoadingDots color="#1E2A54" /> : t("login")}
        </button>
        <p className="mx-auto text-retta-green mt-16 text-lg text-center">
          {t("no-username")}
        </p>
        <p className="mx-auto text-retta-green text-lg text-center w-[100%] max-w-96">
          {t("please-contact")}
        </p>
      </div>
    </main>
  );
};

export default Login;
